export const config = {
  title: `Hire cars,\nLike never Before`,
  subtitle: `24 HOURS 7 DAYS A WEEK`,
}
